import React, { useContext, useEffect, useState } from 'react'
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import { getAgentesCompras } from '../../../../API/Global/Agentes/AgentesRequests';
import { ConfirmDialog } from 'primereact/confirmdialog';

import AgenteComprasDropDown from './AgentesComprasDropDown';
import RequisaComprasModalCrud from '../CrudRequisa/RequisaComprasModalCrud';
import { getPermisoCostosUser } from '../../../../API/IT/Usuarios/AccesosUserRequets';

const PurcharesDetails = ({ detalles, toast, loading, setDetalles, setRequisaEdit, setShowDialog, selectedDetalle, setSelectedDetalle }) => {

    const { userAuth } = useContext(AuthContext);

    const estadosPD = ['Solicitado', 'Aprobado', 'Cotizado', 'En Firma'];
    const estados = [{estado: 'Solicitado'},{estado: 'Aprobado'}, {estado: 'Cotizado'}, {estado: 'En Firma'}];
    const prioridades = ["Urgente", "Alta", "Media", "Baja"];

    const [agentesCompras, setAgentesCompras] = useState([]);
    const [visibleMailDialog, setVisibleMailDialog] = useState(false);

    const [permisoCostos, setpermisoCostos] = useState(false);






    const obtenerAgentesCompras = async () => {
        const tempo = await getAgentesCompras();
        let lista = [];
        let Agents = [];
        tempo.forEach((e) => {
            Agents.push(e)
            lista.push(e.AgentName);
        });
        setAgentesCompras(Agents)
        const d = await getPermisoCostosUser(userAuth.idUser);
        if(d.length > 0){
            setpermisoCostos(d[0].acceso);
        }
    }

    const enviarCorreoAsignarRequisa = async () => {
        //TODO
        // const promesa = await fetch(`${instancias.API_URL}/email/asignarRequisa/${purchase.IdPurchaseRequest}`, {
        //     method: "GET",
        //     headers: {
        //         "Content-Type": "application/json",
        //         'x-access-token': localStorage.getItem('ppfToken')
        //     }
        // })
        // promesa.json()
        //     .then(result => {
        //         toastShow(toast, 'success', 'Asignado', `Se ha enviado el correo.`);
        //     })
        //     .catch(error => {
        //         toastShow(toast, 'error', 'No enviado', `Error al enviar el correo.`);
        //     });
    }

    const columns = [
        {
            header: 'ID',
            field: 'IdPurcharesRequestDetail',
            className: "Xsmall",
            frozen: "frozen",
            alignFrozen: "left",
            hidden: userAuth?.IdRol === 1
        },
        {
            // ESTADO
            field: 'EstadoPD',
            header: 'Estado',
            className: "small",
            body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.EstadoPD }),
            frozen: "frozen",
            alignFrozen: "left",
            Format: 'Estado'
        },
        {
            // NUMERO ORDEN
            field: 'PurchaseRequest',
            header: 'No. Requisa',
            className: "small",
            body: (rowData) => (rowData.PurchaseRequest),
            frozen: "frozen",
            alignFrozen: "left",
            Sumary: 'count',
            align: 'center',
            Format: 'Modal'
        },
        {
            // RequestType
            field: 'RequestType',
            header: 'Tipo Requisass',
            className: "small",
            body: (rowData) => (rowData.RequestType),
            align: 'center',

        },
        {
            // Priority
            field: 'Priority',
            header: 'Prioridad',
            className: "small",
            body: (rowData) => ({ ID: rowData.Priority, Estado: rowData.Priority }),
            align: 'center',
            Format: 'Estado'
        },
        {
            // FechaPermiso4
            field: 'FechaPermiso4',
            header: 'Fecha Liberada',
            // className: "large",
            align: 'center',
            Format: 'Date'
        },
        {
            // NombreProducto
            field: 'NombreProducto',
            header: 'Producto',
            className: "Xlarge",
            body: (rowData) => (rowData.NombreProducto),
        },
        {
            // Proveedor
            field: 'Proveedor',
            header: 'Proveedor',
            className: "Xlarge",
            body: (rowData) => (rowData.Proveedor),
        },
        {
            // AgentName
            field: 'AgentName',
            header: 'Asignado a',
            className: "Xlarge",
            body: (rowData) => (rowData.AgentName),
            editable: userAuth?.IdRol === 1 ? true : [213, 83].includes(userAuth?.idUser) ? true : false,
            cellEditor: (data) => <AgenteComprasDropDown data={data} agentesCompras={agentesCompras} toast={toast} setVisibleMailDialog={setVisibleMailDialog} listadoDetalleRequisiciones={detalles} setlistadoDetalleRequisiciones={setDetalles} />,
        },
        {
            // PurchaseOrder
            field: 'PurchaseOrder',
            header: 'Orden compra',
            className: "small",
            body: (rowData) => (rowData.PurchaseOrder),
        },

        {
            // Quantity
            field: 'Inventario',
            header: 'Inventario',
            className: "Xsmall",
            body: (rowData) => (rowData.Inventario),
            Format: 'Decimal',
            Sumary: 'sum',
        },
        {
            // Quantity
            field: 'Quantity',
            header: 'Cantidad',
            className: "Xsmall",
            body: (rowData) => (rowData.Quantity),
            Format: 'Decimal',
            Sumary: 'sum',
        },
        {
            // Price
            field: 'Price',
            header: 'Precio',
            className: "Xsmall",
            body: (rowData) => (rowData.Price),
            Format: 'Currency',
            hidden: permisoCostos,
        },
        {
            //ISV
            field: 'ISV',
            header: 'ISV',
            className: "Xsmall",
            body: (rowData) => (rowData.ISV),
            Format: 'Currency',
            hidden: permisoCostos,
            Sumary: 'sum',
        },
        {
            //Descuento
            field: 'Descuento',
            header: 'Descuento',
            className: "Xsmall",
            body: (rowData) => (rowData.Descuento),
            Format: 'Currency',
            hidden: permisoCostos,
            Sumary: 'sum',
        },
        {
            //SubTotal
            field: 'SubTotal',
            header: 'SubTotal',
            className: "Xsmall",
            body: (rowData) => (rowData.SubTotal),
            Format: 'Currency',
            hidden: permisoCostos,
            Sumary: 'sum',
        },
        {
            // Total
            field: 'Total',
            header: 'Total',
            className: "Xsmall",
            body: (rowData) => (rowData.Quantity),
            Format: 'Decimal',
            hidden: permisoCostos,
            Sumary: 'sum',
        },
        {
            // CurrencySymbol
            field: 'CurrencySymbol',
            header: 'Moneda',
            className: "small",
            body: (rowData) => (rowData.CurrencySymbol),
            Format: 'CurrencySymbol',
            align: 'center'
        },
        {
            // Area
            field: 'Area',
            header: 'Área',
            className: "medium",
            body: (rowData) => (rowData.Area),
        },
        {
            // Comment
            field: 'Comment',
            header: 'Comentarios',
            className: "XXlarge",
            body: (rowData) => (rowData.Comment),
        },
        {
            // DateCreated
            field: 'DateCreated',
            header: 'Fecha Creada',
            className: "large",
            body: (rowData) => (rowData.DateCreated),
            Format: 'DateTime',
            sort: 'desc',
        },
        {
            // Description
            field: 'Description',
            header: 'Decripción',
            className: "XXlarge",
            body: (rowData) => (rowData.Description),
        },
        {
            // Dias
            field: 'Dias',
            header: 'Días',
            className: "Xsmall",
            body: (rowData) => (rowData.Dias),
            Format: 'Dias'
        },
        {
            // FechaPOD
            field: 'FechaPOD',
            header: 'Fecha OC',
            className: "large",
            body: (rowData) => (rowData.FechaPOD),
            Format: 'DateTime'
        },
        {
            // CodigoProducto
            field: 'CodigoProducto',
            header: 'Codigo Producto',
            className: "small",
            body: (rowData) => (rowData.CodigoProducto),
        },
        {
            //TipoSuministro
            field: 'RequestType',
            header: 'Tipo',
            className: "small",
            body: (rowData) => (rowData.TipoSuministro),
        },
        {
            //AssignDate
            field: 'AssignDate',
            header: 'Fecha Asignada',
            // className: "large",
            body: (rowData) => (rowData.AssignDate),
            Format: 'DateTime'
        },
        {
            //EstadoPR
            field: 'EstadoPR',
            header: 'Estado General',
            className: "small",
            body: (rowData) => ({ ID: rowData.EstadoPR, Estado: rowData.EstadoPR }),
            Format: 'Estado'
        },
        {
            //EstadoPR
            field: 'PurchaseOrder',
            header: 'SalesOrder',
            className: "small",
            body: (rowData) => (rowData.PurchaseOrder),
        },
        {
            //Lempiras
            field: 'TotalL',
            header: 'Lempiras',
            className: "small",
            body: (rowData) => (rowData.TotalL),
            Format: 'Currency',
            hidden: permisoCostos,
            Sumary: 'sum',
        },
        {
            //Dolares
            field: 'TotalD',
            header: 'Dolares',
            className: "small",
            body: (rowData) => (rowData.TotalD),
            Format: 'Currency',
            hidden: permisoCostos,
            Sumary: 'sum',
        },
        {
            //Euros
            field: 'TotalE',
            header: 'Euros',
            className: "small",
            body: (rowData) => (rowData.TotalE),
            Format: 'Currency',
            hidden: permisoCostos,
            Sumary: 'sum',
        },
        {
            //ASolicita
            field: 'ASolicita',
            header: 'Solicita',
            className: "large",
            body: (rowData) => (rowData.ASolicita),
        },
        {
            //ASolicita
            field: 'NombreCategoria',
            header: 'Categoria',
            className: "large",
            body: (rowData) => (rowData.NombreCategoria),
        },
        {
            //UnitSimbol
            field: 'UnitSimbol',
            header: 'Unidad',
            className: "small",
            body: (rowData) => (rowData.UnitSimbol),
            align: 'center'
        },
        {
            //FechaPermiso1
            field: 'FechaPermiso1',
            header: 'Fecha Finanzas',
            className: "large",
            body: (rowData) => (rowData.FechaPermiso1),
            Format: 'DateTime'
        },
        {
            //FechaPermiso3
            field: 'FechaPermiso3',
            header: 'Fecha P. Manager',
            className: "large",
            body: (rowData) => (rowData.FechaPermiso3),
            Format: 'DateTime'
        },
        {
            //FechaCotizacion
            field: 'FechaCotizacion',
            header: 'Fecha precio',
            className: "large",
            body: (rowData) => (rowData.FechaCotizacion),
            Format: 'DateTime'
        },
        {
            //UsuarioPermiso4
            field: 'UsuarioPermiso4CheckBox',
            header: 'Gerente Area',
            className: "small",
            body: (rowData) => rowData.UsuarioPermiso4 !== null,
            Format: 'Checkbox'
        },
        {
            //UsuarioPermiso4
            field: 'UsuarioPermiso4',
            header: 'Usuario Auth',
            className: "small",
            body: (rowData) => rowData.UsuarioPermiso4,
        },
        {
            //ConPrecio
            field: 'ConPrecio',
            header: 'Con precio',
            className: "small",
            body: (rowData) => rowData.ConPrecio,
            Format: 'Checkbox',
            frozen: "frozen",
            alignFrozen: "right",
        },
        {
            //Permiso1
            field: 'Permiso1',
            header: 'Finanzas',
            className: "small",
            body: (rowData) => rowData.Permiso1,
            Format: 'Checkbox',
            frozen: "frozen",
            alignFrozen: "right",
            hidden: permisoCostos,
        },
        {
            //Permiso3
            field: 'Permiso3',
            header: 'Plant Manager',
            className: "Xsmall",
            body: (rowData) => rowData.Permiso3,
            Format: 'Checkbox',
            frozen: "frozen",
            alignFrozen: "right",
            hidden: permisoCostos,
        },

    ];

    const table = {
        Columns: columns,
        Data: detalles,
        fileName: "RequisasCompras" + (new Date()).toDateString(),
        loading: loading,
        clases: "tablaListados",
        selected: selectedDetalle,
        setSelected: e => setSelectedDetalle(e),
        showModal: e => showModal(e),
        key: 'IdPurcharesRequestDetail',
        Estados: estadosPD,
        Prioridades: prioridades,
        editType: 'fullRow'
    }

    const showModal = (purchaseRequest) => {
        setRequisaEdit(purchaseRequest);
        setShowDialog(true);
    }


    useEffect(() => {
        obtenerAgentesCompras();
    }, [])

    return (
        <div style={{ height: '82vh' }}>
            <AgGrid table={table} />
            <ConfirmDialog className='modal__contenedor' visible={visibleMailDialog} onHide={() => setVisibleMailDialog(false)} message="¿Desea enviar correo de asignación?"
                header="Confirmation" icon="pi pi-exclamation-triangle" accept={enviarCorreoAsignarRequisa} />

        </div>
    )
}

export default PurcharesDetails